import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade} from 'swiper/core';
import SliderConfig from '../../../config/slider-settings';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);
class SliderComponentItem {
    constructor(el, index) {
        this.render(el, index);
    } 

    render (el, index) {
        this.element = $(el);
        this.config = this.element.data('slideSettings');

        var settings = SliderConfig[this.config] || {};
        const swiper = new Swiper(el, settings);
    }
}

class SliderComponent {
    constructor(selector) {
        
        this.all = document.querySelectorAll(selector);
        for ( var i = 0; i < this.all.length; i++ ) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new SliderComponentItem(el, index);
    }
}

export default SliderComponent;